import { FC } from 'react';
import styled from 'styled-components';
import {FlexBox, Dropdown, DropdownListItem, Colors, FInter, useIsMobile} from '@brg/ui';
import {useHistory} from "react-router-dom";

export const ProjectsImage = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="4" height="4" fill="#C5C6C7" />
        <rect x="2" y="10" width="4" height="4" fill="#C5C6C7" />
        <rect x="2" y="18" width="4" height="4" fill="#C5C6C7" />
        <rect x="10" y="2" width="4" height="4" fill="#C5C6C7" />
        <rect x="10" y="10" width="4" height="4" fill="#C5C6C7" />
        <rect x="10" y="18" width="4" height="4" fill="#C5C6C7" />
        <rect x="18" y="2" width="4" height="4" fill="#C5C6C7" />
        <rect x="18" y="10" width="4" height="4" fill="#C5C6C7" />
        <rect x="18" y="18" width="4" height="4" fill="#C5C6C7" />
    </svg>
);

export const ProjectsWhiteImage = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="4" height="4" fill="#8e9193" />
        <rect x="2" y="10" width="4" height="4" fill="#8e9193" />
        <rect x="2" y="18" width="4" height="4" fill="#8e9193" />
        <rect x="10" y="2" width="4" height="4" fill="#8e9193" />
        <rect x="10" y="10" width="4" height="4" fill="#8e9193" />
        <rect x="10" y="18" width="4" height="4" fill="#8e9193" />
        <rect x="18" y="2" width="4" height="4" fill="#8e9193" />
        <rect x="18" y="10" width="4" height="4" fill="#8e9193" />
        <rect x="18" y="18" width="4" height="4" fill="#8e9193" />
    </svg>
);

export const NavbarProjectsWidgetWrapper = styled(FlexBox)`
    height: 64px;
    align-items: center;
    cursor: pointer;
`;

type NavbarProjectsWidgetPropsT = {
    links: Record<string, string>;
    theme: any;
};

export const NavbarProjectsWidget: FC<NavbarProjectsWidgetPropsT> = ({ links, theme }) => {
    const isMobile = useIsMobile();
    return (
    <NavbarProjectsWidgetWrapper>
        <Dropdown
            offsetY={2}
            offsetX={isMobile ? -130 : -88}
            offsetArrowX={26}
            offsetArrowY={0}
            target={theme ? <ProjectsWhiteImage /> : <ProjectsImage />}
        >
            {Object.keys(links).map((value) => (
                <DropdownListItem
                    style={{cursor: links[value] === '' ? 'not-allowed' : 'pointer'}}
                    key={value}
                    onClick={() => links[value] === '' ? true : window.location.href = links[value]}
                >
                    {
                        links[value][0] === "/"
                            ?
                            <NavItemInternal link={links[value]} title={value} disabled={links[value]===""} />
                            :
                            <NavItemForeign
                                link={links[value]}
                                title={value}
                                disabled={links[value] === ''}
                            />
                    }
                </DropdownListItem>
            ))}
        </Dropdown>
    </NavbarProjectsWidgetWrapper>
)};

type NavItemPropsT = {
    title: string;
    link: string;
    disabled?: boolean;
};

export const NavItemForeign: FC<NavItemPropsT> = ({ title, link, disabled }) => (
    <FInter.SmallTextBoldMagic
        style={{ opacity: disabled ? 0.3 : 1 }}
        key="foreign1"
        pointer={true}
        color={Colors.galBlack73}
        justify="center"
        align="center"
        hoverColor={Colors.galBlack100}
        onClick={() => (disabled ? null : window.open(link))}
        disabled={disabled}
    >
        <div>{title}</div>
        <div>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    opacity="0.5"
                    d="M12 10.7149H10.3329L10.3431 6.86984L5.21474 12L4 10.786L9.12833 5.65587H5.27573L5.2859 4H12V10.7149Z"
                    fill="#151514"
                />
            </svg>
        </div>
    </FInter.SmallTextBoldMagic>
);

export const NavItemInternal: FC<NavItemPropsT> = ({ title, link, disabled }) => {
    const history = useHistory();
    return (
        <FInter.SmallTextBoldMagic
            style={{ opacity: disabled ? 0.3 : 1 }}
            key={'internal'}
            pointer={true}
            color={Colors.galBlack73}
            justify={'center'}
            align={'center'}
            hoverColor={Colors.galBlack100}
            onClick={() => (disabled ? null : history.push(link))}
            disabled={disabled}
        >
            <div>{title}</div>
        </FInter.SmallTextBoldMagic>
    );
};
import { FC } from 'react';
import styled from 'styled-components';
import {FlexBox, Dropdown, DropdownListItem, Colors, FInter, useIsMobile} from '@brg/ui';
import {useHistory} from "react-router-dom";

export const ProjectsImage = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="4" height="4" fill="#C5C6C7" />
        <rect x="2" y="10" width="4" height="4" fill="#C5C6C7" />
        <rect x="2" y="18" width="4" height="4" fill="#C5C6C7" />
        <rect x="10" y="2" width="4" height="4" fill="#C5C6C7" />
        <rect x="10" y="10" width="4" height="4" fill="#C5C6C7" />
        <rect x="10" y="18" width="4" height="4" fill="#C5C6C7" />
        <rect x="18" y="2" width="4" height="4" fill="#C5C6C7" />
        <rect x="18" y="10" width="4" height="4" fill="#C5C6C7" />
        <rect x="18" y="18" width="4" height="4" fill="#C5C6C7" />
    </svg>
);

export const ProjectsWhiteImage = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="4" height="4" fill="#8e9193" />
        <rect x="2" y="10" width="4" height="4" fill="#8e9193" />
        <rect x="2" y="18" width="4" height="4" fill="#8e9193" />
        <rect x="10" y="2" width="4" height="4" fill="#8e9193" />
        <rect x="10" y="10" width="4" height="4" fill="#8e9193" />
        <rect x="10" y="18" width="4" height="4" fill="#8e9193" />
        <rect x="18" y="2" width="4" height="4" fill="#8e9193" />
        <rect x="18" y="10" width="4" height="4" fill="#8e9193" />
        <rect x="18" y="18" width="4" height="4" fill="#8e9193" />
    </svg>
);

export const NavbarProjectsWidgetWrapper = styled(FlexBox)`
    height: 64px;
    align-items: center;
    cursor: pointer;
`;

type NavbarProjectsWidgetPropsT = {
    links: Record<string, string>;
    theme: any;
};

export const NavbarProjectsWidget: FC<NavbarProjectsWidgetPropsT> = ({ links, theme }) => {
    const isMobile = useIsMobile();
    return (
    <NavbarProjectsWidgetWrapper>
        <Dropdown
            offsetY={2}
            offsetX={isMobile ? -130 : -88}
            offsetArrowX={26}
            offsetArrowY={0}
            target={theme ? <ProjectsWhiteImage /> : <ProjectsImage />}
        >
            {Object.keys(links).map((value) => (
                <DropdownListItem
                    style={{cursor: links[value] === '' ? 'not-allowed' : 'pointer'}}
                    key={value}
                    onClick={() => links[value] === '' ? true : window.location.href = links[value]}
                >
                    {
                        links[value][0] === "/"
                            ?
                            <NavItemInternal link={links[value]} title={value} disabled={links[value]===""} />
                            :
                            <NavItemForeign
                                link={links[value]}
                                title={value}
                                disabled={links[value] === ''}
                            />
                    }
                </DropdownListItem>
            ))}
        </Dropdown>
    </NavbarProjectsWidgetWrapper>
)};

type NavItemPropsT = {
    title: string;
    link: string;
    disabled?: boolean;
};

export const NavItemForeign: FC<NavItemPropsT> = ({ title, link, disabled }) => (
    <FInter.SmallTextBoldMagic
        style={{ opacity: disabled ? 0.3 : 1 }}
        key="foreign1"
        pointer={true}
        color={Colors.galBlack73}
        justify="center"
        align="center"
        hoverColor={Colors.galBlack100}
        onClick={() => (disabled ? null : window.open(link))}
        disabled={disabled}
    >
        <div>{title}</div>
        <div>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    opacity="0.5"
                    d="M12 10.7149H10.3329L10.3431 6.86984L5.21474 12L4 10.786L9.12833 5.65587H5.27573L5.2859 4H12V10.7149Z"
                    fill="#151514"
                />
            </svg>
        </div>
    </FInter.SmallTextBoldMagic>
);

export const NavItemInternal: FC<NavItemPropsT> = ({ title, link, disabled }) => {
    const history = useHistory();
    return (
        <FInter.SmallTextBoldMagic
            style={{ opacity: disabled ? 0.3 : 1 }}
            key={'internal'}
            pointer={true}
            color={Colors.galBlack73}
            justify={'center'}
            align={'center'}
            hoverColor={Colors.galBlack100}
            onClick={() => (disabled ? null : history.push(link))}
            disabled={disabled}
        >
            <div>{title}</div>
        </FInter.SmallTextBoldMagic>
    );
};
